(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("dayjs"));
	else if(typeof define === 'function' && define.amd)
		define(["dayjs"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("dayjs")) : factory(root["dayjs"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__9185__) {
return 